export enum AppMarketsEnum {
	AppStore = 'App Store',
	PlayMarket = 'Play Market'
}
